import React, { useState } from 'react';
import { Star, MapPin, Clock, Phone, Mail, Tag, ChevronRight, Heart, Share2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { VENDOR_PRODUCT_ROUTE } from '../../../routes/web/rootRoutes';
import img from "../../../assets/img1.jpg"
import { getFileUrl } from '../../../utils/helper';

const VendorCard = ({ vendor }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Link
      to={VENDOR_PRODUCT_ROUTE(vendor?._id)}
      className="group block bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-gray-100"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="relative h-52 overflow-hidden bg-gray-50">
        <img
          src={getFileUrl(vendor.logo) ?? img}
          alt={vendor.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />

        <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        {vendor.name && (
          <div className="absolute top-3 left-3 bg-white px-3 py-1 rounded-lg shadow-md">
            <p className="text-xl capitalize font-semibold text-gray-700">
              {vendor.displayName}
            </p>
          </div>
        )}

        <div className={`absolute inset-0 flex items-center justify-center transition-all duration-300 ${isHovered ? 'opacity-100' : 'opacity-0'}`}>
          <div className="bg-white px-6 py-3 rounded-xl shadow-xl">
            <h2 className="text-xl font-bold capitalize text-gray-800 text-center">
              {vendor?.addedBy?.name}
            </h2>
          </div>
        </div>

      </div>

      <div className="p-4">
        <div className="flex justify-between items-center gap-2 mb-2">
          <img
            src={getFileUrl(vendor?.vendorLogo) ?? img}
            alt={vendor.name}
            className="w-10 h-10 object-cover rounded-full transition-transform duration-500 group-hover:scale-105"
          />

          <h3 className="text-xl font-bold capitalize text-gray-900  truncate group-hover:text-green-600 transition-colors">
            {vendor?.addedBy?.name}
          </h3>

      

        </div>

       

        <div className="flex justify-between items-center">
          <div className="flex items-center gap-1.5 text-gray-600">
            <MapPin size={14} className="text-green-600" />
            <span className="text-sm truncate">
              {vendor.cityId?.name || vendor.location}
            </span>
          </div>

          <div className=" flex items-center gap-1 bg-green-500 text-white px-2.5 py-1 rounded-lg shadow-md">
            <Star size={12} fill="white" />
            <span className="text-xs font-bold">{vendor.rating || '4.7'}</span>
          </div>
        </div>
      </div>
    </Link>
  );
};
export default VendorCard;